
import React, { useState, useEffect } from 'react';
import { Typography, TextField, Box } from '@mui/material';
import CommonModal from '../../../UserScreen/InventoryPage/InventorySettings/components/Modals/CommonModal';

interface RebootTerminalDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: (notes: string) => void;
    kitSerialNumber?: string;
    title?: string;
}

const RebootTerminalDialog: React.FC<RebootTerminalDialogProps> = ({ open, onClose, onConfirm, kitSerialNumber, title = "Reboot" }) => {
    const [rebootNotes, setRebootNotes] = useState('');

    useEffect(() => {
        if (!open) {
            setRebootNotes('');
        }
    }, [open]);

    return (
        <CommonModal
            open={open}
            onClose={onClose}
            onSave={() => onConfirm(rebootNotes)}
            title={title}
            saveText="Reboot"
            cancelText="Cancel"
            maxWidth="480px"
            titleWithDeleteIcon={true}
            showOnlineOffline={false}
            showSyncStatus={false}
        >
            <Box sx={{ p: 3, textAlign: 'center' }}>
                <Box sx={{ fontFamily: "Inter", fontWeight: 400, fontSize: "14px", lineHeight: "20px", color: "#6E7079", mb: 1 }}>
                    {kitSerialNumber 
                        ? `Are you sure you want to reboot your Starlink ${kitSerialNumber} ?`
                        : `Are you sure you want to reboot starlink ?`}
                </Box>
                <Box sx={{ fontFamily: "Inter", fontWeight: 400, fontSize: "14px", lineHeight: "20px", color: "#6E7079", mb: 3 }}>
                    This will temporarily interrupt service.
                </Box>
                <Typography fontWeight={"550"} component="div" sx={{ textAlign: "left", fontSize: "14px" }}>Notes:</Typography>
                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    variant="outlined"
                    placeholder="Add notes..."
                    value={rebootNotes}
                    onChange={(e) => setRebootNotes(e.target.value)}
                    sx={{
                        mt: 1,
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                            backgroundColor: '#fff',
                        }
                    }}
                />
            </Box>
        </CommonModal>
    );
};

export default RebootTerminalDialog;

